module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/modena.b3084d2a0408e988c51e55290663de5c.jpg";